import React from 'react'

export const formoptions = React.createContext()